module.exports = __webpack_public_path__ + "img/shuttle.d7140092.png";